import type { PlanogramDeliveryTranslations } from "../en/PlanogramDelivery";
import type { TranslationShape } from "../../store/types";

export const planogramDeliveryEs: TranslationShape<PlanogramDeliveryTranslations> = {
  previewPdf: {
    button: "Vista previa de PDF",
    searchPlaceholder: "Buscar historial de entregas",
    mostRecent: "Más reciente (auto)",
    noResults: "No se encontraron entregas coincidentes.",
  },
  markDelivered: {
    action: "Marcar como entregado",
    approveFirstTooltip: "Aprueba este planograma primero para marcarlo como entregado",
    toastDelivered: "Marcado como entregado",
    toastAlreadyDelivered: "Este planograma ya había sido marcado como entregado",
    bulkAction: "Marcar todo como entregado",
    bulkSummary: "{{delivered}} marcados como entregados · {{alreadyDelivered}} ya entregados",
    bulkSkippedSuffix: " · {{skipped}} omitidos — aún no aprobados",
    showSkipped: "Mostrar tiendas omitidas",
    hideSkipped: "Ocultar tiendas omitidas",
    skippedStores: "Tiendas omitidas: {{stores}}",
  },
  itemSummary: {
    noDeliveryHistory:
      "No hay entregas previas registradas para esta tienda/categoría — todos los artículos se muestran como nuevos.",
    comparisonError:
      "No se pudo cargar la entrega de comparación solicitada — todos los artículos se muestran como nuevos.",
  },
  deleteMerchflow: {
    deletedToast: 'Merchflow "{{name}}" eliminado exitosamente',
    confirmTitle: '¿Eliminar "{{name}}"?',
    confirmDescriptionSingular:
      "Este merchflow tiene {{count}} entrega de planograma registrada. Eliminarlo también eliminará permanentemente ese historial de entregas. Esta acción no se puede deshacer.",
    confirmDescriptionPlural:
      "Este merchflow tiene {{count}} entregas de planograma registradas. Eliminarlo también eliminará permanentemente ese historial de entregas. Esta acción no se puede deshacer.",
    deleteAnyway: "Eliminar de todos modos",
  },
  jdaImport: {
    modalTitle: "Importar Línea Base de JDA — {{categoryCode}}",
    roleLabels: {
      site: "JDA Site",
      shelf: "JDA Shelf",
      articleMaster: "Article Master",
    },
    notYetAdded: "aún no agregado",
    couldntIdentifySingular: "No se pudo identificar este archivo — elige a cuál corresponde:",
    couldntIdentifyPlural:
      "No se pudieron identificar estos archivos — elige a cuál corresponde cada uno:",
    chooseType: "Elegir tipo",
    batchDate: "Fecha del lote",
    resultSummary:
      "Se importaron {{imported}} línea(s) base, se omitieron {{skippedEmpty}} par(es) vacío(s), se omitieron {{skippedExisting}} par(es) ya importado(s).",
    upload: "Subir",
    categoriesActionLabel: "LÍNEA BASE JDA",
    categoriesDisabledTooltip:
      "Primero habilita la importación de JDA para este merchant en Configuración",
  },
  variantRestrictionDescribe: {
    categoriesActionLabel: "RESTRICCIÓN DE VARIANTE (DESCRIBIR)",
    modalTitle: "Describir restricciones de variantes — {{categoryCode}}",
    descriptionTitle: "Describe las reglas en lenguaje natural",
    placeholder:
      "Mantén el alcohol fuera de los dos estantes superiores en las tiendas 1023 y 1044. Coca-Cola debe estar en el estante inferior en todas las tiendas.",
    appendHelp:
      'Describe otro conjunto y añádelo, o añádelo a un grupo por nombre (p. ej., "añadir GALLETAS al Grupo 1").',
    replaceAll: "Reemplazar todo",
    addToRules: "Añadir a las reglas",
    generateRules: "Generar reglas",
    reviewRules:
      "Revisa antes de guardar: cada regla apunta a una bahía y un estante (usa * para todos)",
    noRules: "Aún no hay reglas; añádelas manualmente abajo",
    summary: "Resumen",
    described: "Descrito:",
    translatedTo: "Traducido a:",
    addedManually: "Añadido manualmente",
    noRulesForDescription: "(sin reglas)",
    everyBay: "todas las bahías",
    everyShelf: "todos los estantes",
    addStoreGroup: "Añadir grupo de tiendas",
    replaceRestrictions: "Reemplazar restricciones",
    missingRuleFields: "Cada regla necesita una variante, una bahía y un estante antes de guardar.",
    resolveStoreCodes: "Resuelve o elimina los códigos de tienda no reconocidos antes de guardar.",
    resolveVariants:
      "Resuelve cada variante no coincidente (usa la sugerencia o «Mantener como se escribió») antes de guardar.",
    loadingStoreScope: "Cargando el ámbito de tiendas… no se puede guardar hasta que termine.",
    storeScopeLoadError:
      "No se pudo cargar el ámbito de tiendas, por lo que guardar está deshabilitado.",
    retry: "Reintentar",
    savingReplaces:
      "Al guardar se reemplazan todas las restricciones de variantes existentes para esta categoría.",
    confirmReplaceTitle: "¿Reemplazar todas las reglas actuales?",
    confirmReplaceDescription:
      "Esto descarta las reglas y ediciones actuales y vuelve a analizar la descripción.",
    confirmApplyTitle: "¿Reemplazar las restricciones de variantes de {{categoryCode}}?",
    confirmApplyDescription:
      "Esto reemplaza todas las restricciones de variantes existentes para esta categoría, incluidas las importadas desde CSV. Esta acción no se puede deshacer.",
    back: "Volver",
    replace: "Reemplazar",
    savedTitle: "Restricciones de variantes guardadas",
    parseFailedTitle: "No se pudieron interpretar esas restricciones",
    parseFailedMessage: "Intenta reformularlas o añade las reglas manualmente abajo.",
    loadStoreFiltersFailed: "No se pudieron cargar los filtros de tiendas",
    saveFailedTitle: "No se pudieron guardar las restricciones de variantes",
    groupName: "Grupo {{index}}",
    removeStoreGroupAriaLabel: "Eliminar grupo de tiendas",
    appliesToStores: "Se aplica a las tiendas",
    storeCodesPlaceholder:
      "Códigos de tienda separados por comas; déjalo vacío para todas las tiendas",
    parsedFilterUnavailable:
      "Filtro de tiendas interpretado (opciones de atributos no disponibles):",
    noStoreFilters: "No hay filtros de tiendas disponibles para esta categoría.",
    filterStoresByAttribute:
      "O filtra las tiendas por atributo (las coincidencias se añaden al ámbito):",
    baySize: "Tamaño de bahía",
    state: "Estado",
    cluster: "Clúster",
    sectionHeight: "Altura de sección",
    sectionWidth: "Anchura de sección",
    any: "Cualquiera",
    appliesToAllStore: "Se aplica a la única tienda de la categoría",
    appliesToAllStores: "Se aplica a las {{count}} tiendas de la categoría",
    appliesToStore: "Se aplica a 1 tienda",
    appliesToStoresCount: "Se aplica a {{count}} tiendas",
    unrecognisedStore: "Tienda no reconocida: {{stores}}",
    unrecognisedStores: "Tiendas no reconocidas: {{stores}}",
    addRule: "Añadir regla",
    condition: "Condición",
    conditionMustHave: "Debe tener",
    conditionMayHave: "Puede tener",
    conditionOnlyThese: "Solo estas",
    conditionMustNotHave: "No debe tener",
    variant: "Variante",
    bay: "Bahía",
    shelf: "Estante",
    all: "Todos",
    allBaysAriaLabel: "Todas las bahías",
    allShelvesAriaLabel: "Todos los estantes",
    removeRuleAriaLabel: "Eliminar regla",
    noExactVariantMatch: "No hay una coincidencia exacta de variante.",
    needsReview: "Requiere revisión antes de guardar.",
    useSuggestion: "Usar «{{suggestion}}»",
    keepAsTyped: "Mantener como se escribió",
    setBayAndShelf:
      "Define una bahía y un estante (p. ej., bahía «1», estante «Superior»). Usa «*» para todas las bahías o todos los estantes.",
    conflictsTitle: "Reglas en conflicto",
    conflictsHelp:
      "Estas reglas se contradicen en los mismos estantes, por lo que no se pueden aplicar ambas. Selecciona qué regla conservar; la otra se elimina.",
    conflictRequiredAndForbidden:
      "«{{variant}}» está a la vez requerida y prohibida en estantes que se superponen.",
    conflictOutsideAllowedSet:
      "«{{variant}}» es obligatoria en un estante cuyas variantes permitidas no la incluyen.",
    keepThisRule: "Conservar esta regla",
    conflictsWithAnotherRule: "Entra en conflicto con otra regla; ver «Reglas en conflicto» abajo.",
    resolveConflicts:
      "Resuelve las reglas en conflicto (conserva una de cada par) antes de guardar.",
  },
};
